// The native way in, when there is one.
//
// On iOS the plugin presents Apple's own trimmer — five seconds, hard cap — and
// reads the frames out of the trimmed clip natively. On Android and the web the
// plugin does not exist and Compose falls back to its own sheet.
import { plugin, isNative } from '../core/native.js';
import { CLIP_FRAMES, CLIP_SECONDS } from './frames.js';
import { GRID_W } from './geometry.js';

const impl = () => (isNative ? plugin('FaxClip') : null);

export const canPickClipNatively = () => !!impl()?.pickClip;

/** @returns {Promise<{frames: string[], delaysMs: number[]}|null>} null when the person cancelled */
export async function pickClipNatively() {
  const p = impl();
  if (!p?.pickClip) return null;
  try {
    const r = await p.pickClip({ maxSeconds: CLIP_SECONDS, frames: CLIP_FRAMES, width: GRID_W });
    const frames = Array.isArray(r?.frames) ? r.frames : [];
    if (!frames.length) return null;
    const per = Math.max(40, Math.round(((Number(r.durationSeconds) || CLIP_SECONDS) * 1000) / frames.length));
    return { frames, delaysMs: frames.map(() => per) };
  } catch (e) {
    if (e?.code === 'cancelled' || /cancel/i.test(String(e?.message))) return null;
    throw e;
  }
}
